import { ShieldLockOutlineIcon } from './ShieldLockOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 7F797AEE-648F-4FB8-BA7F-4EF60235A061
 * name shield-lock-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-lock-outline.svg
 * tags
 * - Lock 
 * - Home Automation 
 */
export const AlarmArmAwayOutlineIcon = ShieldLockOutlineIcon;
export default AlarmArmAwayOutlineIcon